
















import Vue from 'vue';

import store from '@/store';

import { WebRequestStatus } from '@/models';
import { BasePacket, Objective, Badge, Outcome } from '@/models/packet';
import * as Icons from '@/icons';

import SinglePointPacketEditor from '@/components/SinglePointPacketEditor.vue';

export default Vue.extend({
  components: {
    SinglePointPacketEditor
  },

  data() {
    return {
      createGoalStatus: WebRequestStatus.READY,
      updateObjectiveStatus: WebRequestStatus.READY
    };
  },

  computed: {
    packet(): BasePacket {
      return store.state.singlePoint.packet;
    },

    objective(): Objective {
      return this.packet.objectives[0];
    },

    badges(): Badge[] {
      return store.state.singlePoint.badges;
    },

    badgeStatuses(): [Badge, WebRequestStatus][] {
      return this.badges.map(b => [b, WebRequestStatus.READY]);
    }
  },

  methods: {
    createGoal(goal: {
      name: string;
      description: string;
      color: string;
      iconData: Icons.IconData;
    }) {
      store.dispatch.singlePoint.createSinglePointGoal(goal);
    },

    updateGoal(updated: { badge: Badge | null; outcome: Outcome | null }) {
      if (updated.badge) {
        store.dispatch.singlePoint.updateBadge(updated.badge);
      }

      if (updated.outcome) {
        store.dispatch.singlePoint.updateOutcome(updated.outcome);
      }
    },

    deleteGoal(outcome: Outcome) {
      store.dispatch.singlePoint.deleteOutcome(outcome);
    },

    updateObjective(objective: Objective) {
      store.dispatch.singlePoint.updateSinglePointBasicInfo(objective);
    }
  }
});
